import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RestoreCartService } from '../../../services/restore-cart.service';
import { Router } from '@angular/router';
import { CmsComponent } from '@spartacus/core';

export interface RestoreCartComponent extends CmsComponent {}

@Component({
  selector: 'cx-restore-cart',
  templateUrl: 'restore-cart.component.html',
  styleUrls: ['restore-cart.component.scss'],
  standalone: false,
})
export class RestoreCartComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;

  constructor(
    private restoreCartService: RestoreCartService,
    private router: Router
  ) {}
  ngOnInit(): void {
    const urlArray = this.router.url.split('/');
    const data = urlArray[urlArray.length - 1];
    this.subscription = this.restoreCartService.restoreCart(data).subscribe({
      next: (path) => {
        this.redirectToPath(path);
      },
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  redirectToPath(path: string) {
    this.router.navigateByUrl(path).then();
  }
}
